<template>
  <div>
    <div id="top">
      <nav-bar />
    </div>
    <div id="side">
      <app-sidebar v-if="currentUser" />
    </div>
    <div id="content" v-bind:class="{ 'push-left': currentUser !== null }">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import NavBar from '@/views/layouts/components/NavBar.vue'
import AppSidebar from '@/views/layouts/components/AppSidebar.vue'

export default {
  name: 'AppLayout',
  data () {
    return { }
  },
  computed: {
    currentUser () {
      return this.$store.state.auth.currentUser
    }
  },
  components: {
    NavBar,
    AppSidebar
  }
}
</script>

<style>
#content {
  min-width: 400px;
  margin-top: 14px;
}
.push-left {
  margin-left: 210px;
}

@media only screen and (max-width: 800px) {
  #side {
    display: none;
  }
  .push-left {
    margin-left: 0px;
  }
}
</style>
